function UserTransactionLogin() {
    "use strict";
    this.__type = 'UserTransactionLogin:www.veritracks.com';
    this.Id = -1;
    this.UserId = -1;
    this.Success = true;
    this.AllowedApps = "NNNNNNNNN";
    this.OrganizationId = -1
    this.BrowserName = '';
    this.BrowserVersion = '';
}
if (typeof exports !== 'undefined') {
    module.exports = UserTransactionLogin;
}